<template>
    <md-content class="card">
        <md-table v-model="orders.content" md-model-id="revisionNumber">
            <md-table-row slot="md-table-row" slot-scope="{ item, index }" class="md-accent"
                          @mouseover="currentHoverIndex = index"
                          @mouseleave="currentHoverIndex = null">
                <md-table-cell :md-label="$t('views.orders.history.table.label.no')">{{ getNo(index) }}</md-table-cell>
                <md-table-cell :md-label="$t('views.orders.history.table.label.status')">
                    {{ $t(`views.order.status.${item.status}`) }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.orders.history.table.label.updatedAt')" md-sort-by="createdAt">
                    {{ item.updatedAt | moment('L LT') }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.orders.history.table.label.updatedBy')">
                    {{ item.updatedBy }}
                </md-table-cell>
                <div class="actions-order-history" v-if="currentHoverIndex === index">
                  <md-button class="md-icon-button" :to="`history/${item.revisionNumber}`"
                             v-if="hasAccess('PRIVILEGE_ORDER_ARCHIVE_GET')">
                    <md-icon>search</md-icon>
                    <md-tooltip md-direction="top">{{ $t('edit') }}</md-tooltip>
                  </md-button>
                </div>
            </md-table-row>
            <md-table-empty-state v-if="!loading" class="md-layout-item md-size-100" :md-label="$t('dialog.noData')" />
            <Spiner :loading="loading" />
        </md-table>
        <div class="md-layout right">
            <paginator :page.sync="currentPage" :length="orders.totalElements || 0" :page-size.sync="pageSize"
                     @pageChange="loadOrderHistory(orderId, currentPage, pageSize, sort)" class="right" />
        </div>
    </md-content>
</template>

<script>
import {ordersEndpoint} from '@/services/adsign-backend/endpoints'
import sortSupport from '@/mixins/sortSupport';
import {mapGetters} from 'vuex';
import Spiner from '@/components/Spiner';
import Paginator from '@/components/Paginator';
import {hasAccess} from "@/utils/jwtUtils";

export default {
    name: 'OrderHistoryList',
    components: {Paginator, Spiner},
    mixins: [sortSupport],
    computed: {
        ...mapGetters('auth', ['hasAccess']),
        ...mapGetters('auth', ['userType'])
    },
    data: () => ({
        orders: {
            totalElements: null,
            content: []
        },
        positions:[],
        currentHoverIndex: null,
        loading: false,
    }),
    props: {
        orderId: {
            type: [Number, String],
            required: true
        },
        position:{
          type: Number,
          default: undefined
      }
    },
  mounted() {
        this.loading = true;
        this.loadOrderHistory(this.orderId, this.currentPage, this.pageSize, '', '')
            .finally(() => {
                this.loading = false;
            })
        this.setActionPosition();
    },
    methods: {
        loadOrderHistory(orderId, page, pageSize, sort, filter) {
            this.loading = true;
            return ordersEndpoint.getOrderHistory(orderId, page - 1, pageSize, sort, filter)
                .then(result => this.orders = result.data)
                .finally(() => {
                  this.loading = false;
                });
        },
        addToPositions(name){
          this.positions.push(name)
        },
      setActionPosition() {
        if(this.position) {
          if (this.position === 1) {
            return "margin-right: -100%";
          } else if (this.position === 2) {
            return "margin-right: -200%";
          } else {
            return "margin-right: -300%";
          }
        }else{
          if(this.hasAccess('PRIVILEGE_INVOICE_LIST_ALL') || this.hasAccess('PRIVILEGE_INVOICE_LIST_ALL')){
            this.addToPositions('invoice')
          }
          if(this.hasAccess('PRIVILEGE_CONTRACT_LIST')){
            this.addToPositions('contract');
          }
          if(position.length==1){
            return "margin-right: -200%"
          }else{
            return "margin-right: -300%"
          }
        }
      }
    }
}
</script>

<style scoped>

</style>
